import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { DxButtonComponent, DxCheckBoxComponent } from 'devextreme-angular';
import { CategorieArticoliService } from 'src/app/shared/services/categorie-articoli.service';
import { CategorieArticoli } from 'src/app/models/categorieArticoli';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { Articoli } from 'src/app/models/articoli';

@Component({
  selector: 'app-filtro-button-categorie-articoli',
  templateUrl: './filtro-button-categorie-articoli.component.html',
  styleUrls: ['./filtro-button-categorie-articoli.component.scss'],
  imports: [DxButtonComponent, DxCheckBoxComponent],
})
export class FiltroButtonCategorieArticoliComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private categoriaArticoliService = inject(CategorieArticoliService);
  @Input() list: Articoli[]=[];
  @Output() eventEmitterFilterCategory = new EventEmitter<number>();
  @Output() articoliAttiviEventEmitter = new EventEmitter<boolean>();

  listCatArt: CategorieArticoli[] = [];
  selectedCat: number = 0;
  attivi: boolean = true;

  ngOnInit() {
    this.loadCategorieArticoli();
  }

  // Lista Categorie
  loadCategorieArticoli() {
    this.categoriaArticoliService.listTemp().subscribe({
      next: (res) => {
        if (res != null) {
          this.listCatArt = res;
        }
      }
    });
  }

  getTitleButton(id: number, descrizione: string) {
    if (id > 0) {
      if(this.attivi){
        return (
        descrizione +
        ' (' +
        this.list?.filter((x) => x.idCategoria == id && x.attivo).length +
        ')'
      );
      }
      return (
        descrizione +
        ' (' +
        this.list?.filter((x) => x.idCategoria == id).length +
        ')'
      );
    } else {
      if(this.attivi){
        return descrizione + ' (' + this.list?.filter(x => x.attivo).length + ')';
      }
      return descrizione + ' (' + this.list?.length + ')';
    }
  }

  filterByCategory(catId: number) {
    this.selectedCat = catId;
    this.eventEmitterFilterCategory.emit(catId);
  }

  onAttiviChanged(e: any){
    this.articoliAttiviEventEmitter.emit(e.value);
  }
}
